import { useHippoText } from '../../hooks/useHippoText';
import ViewInformationModal from '../ViewInformationModal/ViewInformationModal';

const ViewRoadAssistanceModal = ({
    showModal,
    closeModal,
    goNext
}: {
    showModal: boolean;
    closeModal: () => void;
    goNext: () => void;
}): React.JSX.Element => {
    const getHippoText = useHippoText();

    return (
        <ViewInformationModal
            closeModal={closeModal}
            showModal={showModal}
            modalProps={{
                title: getHippoText('DSS-INFO-MODAL-UVPLOB-ROAD-ASSISTANCE-WARNING-TITLE'),
                description: getHippoText('DSS-INFO-MODAL-UVPLOB-ROAD-ASSISTANCE-WARNING-BODY'),
                rawHtmlDescription: '',
                mainButtonText: getHippoText(
                    'DSS-INFO-MODAL-UVPLOB-ROAD-ASSISTANCE-WARNING-CONTINUE'
                ),
                isShowSecondaryButton: true,
                onMainButtonClick: goNext,
                onSecondaryButtonClick: closeModal,
                secondaryButtonTheme: 'secondary',
                secondaryButtonText: getHippoText(
                    'DSS-INFO-MODAL-UVPLOB-ROAD-ASSISTANCE-WARNING-CHOOSE-ANOTHER-PACKAGE'
                )
            }}
        />
    );
};

export default ViewRoadAssistanceModal;
